import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";
export const API = BACKEND_URL ? `${BACKEND_URL}/api` : "/api";

const client = axios.create({ baseURL: API, withCredentials: true });

export const api = {
  // Auth
  me: () => client.get("/auth/me").then((r) => r.data),
  logout: () => client.post("/auth/logout").then((r) => r.data),

  // Today
  getToday: () => client.get("/today").then((r) => r.data),

  // Tasks
  listTasks: (status) =>
    client.get("/tasks", { params: status ? { status } : {} }).then((r) => r.data),
  createTask: (data) => client.post("/tasks", data).then((r) => r.data),
  updateTask: (id, data) => client.put(`/tasks/${id}`, data).then((r) => r.data),
  deleteTask: (id) => client.delete(`/tasks/${id}`).then((r) => r.data),

  // Brain dump
  sortBrainDump: (text) =>
    client.post("/brain-dump/sort", { text }).then((r) => r.data),
  saveBrainDump: (raw_text, items) =>
    client.post("/brain-dump/save", { raw_text, items }).then((r) => r.data),
  brainDumpCategories: () =>
    client.get("/brain-dump/categories").then((r) => r.data),

  // Next right thing
  nextRightThing: (data) =>
    client.post("/next-right-thing", data).then((r) => r.data),

  // Trust deposits
  listTrustDeposits: () => client.get("/trust-deposits").then((r) => r.data),
  createTrustDeposit: (promise) =>
    client.post("/trust-deposits", { promise }).then((r) => r.data),
  completeTrustDeposit: (id) =>
    client.put(`/trust-deposits/${id}/complete`).then((r) => r.data),
  uncompleteTrustDeposit: (id) =>
    client.put(`/trust-deposits/${id}/uncomplete`).then((r) => r.data),
  deleteTrustDeposit: (id) =>
    client.delete(`/trust-deposits/${id}`).then((r) => r.data),

  // Wins
  winsToday: () => client.get("/wins/today").then((r) => r.data),
  winsHistory: () => client.get("/wins/history").then((r) => r.data),

  // Parking lot
  listParkingLot: () => client.get("/parking-lot").then((r) => r.data),
  createIdea: (data) => client.post("/parking-lot", data).then((r) => r.data),
  updateIdea: (id, data) => client.put(`/parking-lot/${id}`, data).then((r) => r.data),
  deleteIdea: (id) => client.delete(`/parking-lot/${id}`).then((r) => r.data),

  // Trash
  getTrash: () => client.get("/trash").then((r) => r.data),
  restoreTrash: (items) => client.post("/trash/restore", { items }).then((r) => r.data),
  purgeTrash: (items) => client.post("/trash/purge", { items }).then((r) => r.data),

  // Settings
  getSettings: () => client.get("/settings").then((r) => r.data),
  updateSettings: (data) => client.put("/settings", data).then((r) => r.data),
  reseed: () => client.post("/seed?force=true").then((r) => r.data),
};

// Toggle a value in a multi-select chip list, never dropping the last one
export const toggleIn = (list, v, allowEmpty = false) =>
  list.includes(v)
    ? (list.length > 1 || allowEmpty ? list.filter((x) => x !== v) : list)
    : [...list, v];

// Normalize an item that may predate multi-select fields
export const listOf = (item, plural, singular) =>
  item?.[plural]?.length ? item[plural] : (item?.[singular] ? [item[singular]] : []);

export const CATEGORIES = [
  "Must do today",
  "Do later",
  "Waiting on someone",
  "Errand",
  "Work / business",
  "Personal / home",
  "Health / fitness",
  "Random idea / parking lot",
];

export const LOCATIONS = ["home", "out", "computer", "phone"];
export const LEVELS = ["low", "medium", "high"];
